import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectRelease } from 'services/store/distribution/selectors';
import { ReleaseFieldType } from 'services/store/distribution/types';
import { isReleasable } from 'services/helpers/distribution';

const useReleaseValidation = (releaseId: string) => {
  const release = useSelector(selectRelease(releaseId));

  const isValid = useMemo(() => {
    if (!release) {
      return false;
    }

    const { status } = release;

    if (!isReleasable(status)) {
      return false;
    }

    const artistName = release[ReleaseFieldType.ArtistName];
    if (!artistName.data || artistName.error || artistName.loading) {
      return false;
    }

    const title = release[ReleaseFieldType.SongTitle];
    if (!title.data || title.error || title.loading) {
      return false;
    }

    const genre = release[ReleaseFieldType.Genre];
    if (!genre.data || genre.error || genre.loading) {
      return false;
    }

    const coverArt = release[ReleaseFieldType.CoverArt];
    if (!coverArt.data || coverArt.error || coverArt.loading) {
      return false;
    }

    return true;
  }, [release]);

  return {
    isValid,
  };
};

export default useReleaseValidation;
